<template>
  <div class="home">
    <!-- 常见问题 -->
    <div class="question" v-if="commonQuestionList && commonQuestionList.length > 0">
      <div class="title_wapper">
        <div class="title">常见问题</div>
        <div class="more" @click="showMore('/document')">
          查看更多
          <img class="more_icon" src="../../assets/images/client/more.png" alt="">
        </div>
      </div>
      <div class="line"></div>
      <ul class="list">
        <li class="item" v-for="item in commonQuestionList" :key="item._id">
          <router-link :to="{ name:'QuestionDetail', query: { id: item._id, type: 'quesion' }}">
            {{item.remark ? '• ' + item.remark : ''}}
          </router-link>
        </li>
      </ul>
    </div>

    <!-- 产品动态 -->
    <div class="product" v-if="dynamicList && dynamicList.length > 0">
      <div class="title_wapper product_wapper">
        <div class="title">产品动态</div>
        <div class="more" @click="showMore('/dynamics')">
          查看更多
          <img class="more_icon" src="../../assets/images/client/more.png" alt="">
        </div>
      </div>
      <div class="table">
        <el-table 
          v-loading="tableLoading" 
          ref="multipleTable" 
          :data="dynamicList" 
          tooltip-effect="dark" 
          border 
          width="100%" 
          class="v2table">
          <el-table-column type="index" width="80" label="序号"></el-table-column>
          <el-table-column prop="production" label="产品" width="150"></el-table-column>
          <el-table-column prop="htmlText" label="更新摘要"></el-table-column>
          <el-table-column prop="displayTime" label="更新日期" width="150"></el-table-column>
          <el-table-column label="详情" width="150">
            <template scope="scope">
              <el-button class="btn-blue" size="mini" @click="handleDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 产品文档 -->
    <div class="document" v-if="productList && productList.length > 0">
      <div class="title_wapper question_wapper">
        <div class="title">产品文档</div>
        <div class="more" @click="showMore('/document')">
          查看更多
          <img class="more_icon" src="../../assets/images/client/more.png" alt="">
        </div>
      </div>
      <ul class="question_ul">
        <li v-for="item in productList" :key="item._id" @click="handleJump(item)">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapActions, mapState } from 'vuex';
  import { clearTag } from '../../utils/util';
  export default {
    name:'Home',
    data() {
      return {
        commonQuestionList: [],//常见问题列表
        dynamicList:[],//产品动态列表
        productList:[],//产品文档列表
        tableLoading: false,
      };
    },
    computed: {
      ...mapState({
        currentClient: state=>state.User.currentClient,
      })
    },
    mounted() {
      // 常见问题
      this.getQuestionClientInfo();
      // 产品动态
      this.getDynamicClientInfo();
      // 产品列表
      this.getProductionClientInfo();
    },
    components: {},
    methods: {
      ...mapActions(['questionClientInfo','dynamicClientInfo','productionClientInfo']),
      // 产品文档
      handleJump(item){
        this.$router.push({
          path: '/document',
          query: {
            id: item._id
          }
        });
      },
      // 常见问题查看更多
      showMore(url){
        this.$router.push(url);
      },
      // 产品动态详情
      handleDetail(row){
        this.$router.push({
          path: '/dynamics/detail',
          query: {
            id: row._id
          }
        });
      },
      //获取常见问题
      getQuestionClientInfo(){
        this.questionClientInfo({
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
          "productionId":"", //关联的产品类型
          "questionTypeid":"", //问题类型
          "commonQuestion": true, //是否常见问题
            p:1,
            s:10   
        }).then(res => {
          this.commonQuestionList = res.items;
        })
      },
      // 获取产品动态
      getDynamicClientInfo(){
        this.dynamicClientInfo({
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
          "productionId":"", //关联的产品类型
          p:1,
          s:10   
        }).then(data => {
          const arr = data.items;
          this.dynamicList = arr.map(item=>{
            let htmlText = clearTag(item.contents);
            if(htmlText && htmlText.length >= 30) {
              item.htmlText = htmlText.slice(0, 30) + '...';
            }else{
              item.htmlText = htmlText;
            }
            return item;
          })
        })
      },
      getProductionClientInfo(){
        this.productionClientInfo({
          "category": this.currentClient,   //产品端  B端:"2B" C端:"2C"
        }).then(list => {
          this.productList = list;
        })
      }
    }
  };
</script>
<style lang="sass" rel="stylesheet/scss" scoped>
  .title_wapper{
    display: flex;
    justify-content: space-between;
    line-height: 16px;
    .title{
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
    .more{
      font-size: 14px;
      color: #333;
      cursor: pointer;
      .more_icon{
        width: 10px;
      }
    }
  }

  .home{
    background-color: #fff;
    padding: 30px 20px;
    .question{
      .line{
        height: 1px;
        width: 100%;
        background-color: #ddd;
        margin: 20px auto 10px;
      }
      .list{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .item{
          width: 45%;
          a{
            display: flex;
            line-height: 36px;
            font-size: 14px;
            color: #333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          a:hover{
            color: #1daef8;
            text-decoration: none;
          }
        }
        .item:nth-of-type(2n+1){
          margin-right: 40px;
        }
      }
    }

    .product{
      overflow: hidden;
      .product_wapper{
        margin: 30px auto 20px;
      }
    }
    .document{
      .question_wapper{
        margin: 40px auto 20px;
      }
      .question_ul{
        display: flex;
        flex-wrap: wrap;
        li{
          min-width:120px;
          height: 40px;
          line-height: 40px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          color: #333;
          margin-bottom: 20px;
          margin-right: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        li:hover{
          color: #1daef8;
          border-color: #1daef8;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?5dcaa7fa